import type { Dtos } from "@inrev/common";
import { Button } from "@portal/components/ui/Button";
import { QuickSubmitLayout } from "./QuickSubmitLayout";
import { AccountDetailsSection } from "./sections/AccountDetailsSection";
import { AgencySection } from "./sections/AgencySection";
import { BondSection } from "./sections/BondSection";
import { CompanySection } from "./sections/CompanySection";

export const CombinedQuickSubmit = ({
	onSubmit,
	openFullSubmission,
	header,
	agentPreviews,
	isSubmitting,
	onCompanyNameBlur,
}: {
	onSubmit: () => void;
	openFullSubmission: () => void;
	header: React.ReactNode;
	agentPreviews: Dtos.Agent.Preview.Get.Response[] | undefined;
	isSubmitting?: boolean;
	onCompanyNameBlur: () => void;
}) => {
	return (
		<QuickSubmitLayout
			openFullSubmission={openFullSubmission}
			header={header}
			fullSubmissionTrackingId="account-admin-combined-escalate"
		>
			<div className="flex flex-col gap-4">
				<div className="grid grid-cols-[1fr_1fr_auto] grid-rows-[1fr_auto_auto] gap-4 pt-[18px]">
					<AgencySection agentPreviews={agentPreviews} />
					<CompanySection onCompanyNameBlur={onCompanyNameBlur} />
					<AccountDetailsSection />
				</div>
				<BondSection />
				<div className="h-0" />
				<Button
					color="confirm"
					filled
					fullWidth
					onClick={onSubmit}
					trackingId="account-admin-combined-quick-submit"
					loading={isSubmitting}
				>
					Submit
				</Button>
			</div>
		</QuickSubmitLayout>
	);
};
